import Application from "../../Application";
import ChangePasswordPresenter, {
  IChangePasswordPresenter,
  TPasswordChangePresentationModel
} from "../../presenter/authentication/ChangePasswordPresenter";

export default class ShowChangePasswordInteractor {
  private application: Application;
  private output?: IChangePasswordPresenter;

  constructor(application) {
    this.application = application;
  }

  execute(username: string, oldPassword: string, token?: string) {
    this.output = ChangePasswordPresenter({
      application: this.application,
      initialState: {
        passwordPresentationModel: {
          oldPassword: oldPassword || ""
        } as TPasswordChangePresentationModel,
        validationPasswordErrors: {},
        isChangeButtonDisabled: false,
        username: username || "",
        isPasswordExpired: true,
        token: token
      }
    });

    return this.output;
  }
}
